import React, { Component } from 'react';
import BaseTree, { TreeNode } from 'rc-tree';
import {connect} from 'react-redux';
import * as apiActions from '../actions/apiEndCategorisActions';


export class Tree extends Component {

	constructor(props){
		super(props);
		this.renderNode = this.renderNode.bind(this);
	}

	renderTitle(node){
		return (
			<span className="tree-node-title">
			    <span>{node.title}</span>
		    </span>
		);
	}

	renderNode(node){
		return (

			<TreeNode key={node.id}  title={this.renderTitle(node)}>
				{node.children && node.children.length ? node.children.map(this.renderNode) : null}
			</TreeNode>

		);
	}
	render() {
		return (
			<div className="App">
				<BaseTree defaultExpandAll={true} showLine selectable={false}>
					{this.props.tree.map(this.renderNode)}
				</BaseTree>
			</div>
		);
	}
}

export const treeBuild = (source_tree) => {
	let links = {};
	let tree = [];
	source_tree.map(item => {
		links[item.id] = Object.assign({}, item);
	});
	Object.values(links).map(item => {
		if(!item.parent_id){
			tree.push(item);
		}else if(links[item.parent_id]){
			let parent = links[item.parent_id];
			if(!parent.children){
				parent.children = [];
			}
			parent.children.push(item);
		}
	});


	return {
		tree,
		links
	};
};



// WEBPACK FOOTER //
// ./frontend/components/Tree.js